import { Renderer, Camera, Transform, Vec3 } from "ogl";

export class Stage {
  constructor(canvas) {
    this.canvas = canvas;
    this.renderer = new Renderer({
      canvas,
      dpr: Math.min(window.devicePixelRatio, 2),
      alpha: true,
      antialias: true,
    });

    this.gl = this.renderer.gl;
    this.gl.clearColor(0.965, 0.973, 0.98, 1);

    this.camera = new Camera(this.gl, { fov: 32, near: 0.1, far: 80 });
    this.camera.position.set(0, 0, 6.2);
    this.camera.lookAt([0, 0, 0]);

    this.scene = new Transform();
    this.ring = new Transform();
    this.ring.setParent(this.scene);

    this.pointerNdc = { x: 0, y: 0 };
    this.pointerWorld = new Vec3();

    this.resize();
    window.addEventListener("resize", () => this.resize());
  }

  resize() {
    const w = window.innerWidth;
    const h = window.innerHeight;
    this.renderer.setSize(w, h);
    this.camera.perspective({ aspect: w / h });
    this.width = w;
    this.height = h;
  }

  worldAtZ0(clientX, clientY) {
    const ndcX = (clientX / this.width) * 2 - 1;
    const ndcY = -(clientY / this.height) * 2 + 1;
    const dist = this.camera.position.z;
    const halfV = Math.tan((this.camera.fov * Math.PI) / 180 / 2) * dist;
    const halfH = halfV * (this.width / this.height);
    this.pointerNdc.x = ndcX;
    this.pointerNdc.y = ndcY;
    this.pointerWorld.set(ndcX * halfH, ndcY * halfV, 0);
    return this.pointerWorld;
  }

  get viewHeight() {
    return (
      Math.tan((this.camera.fov * Math.PI) / 180 / 2) *
      this.camera.position.z *
      2
    );
  }

  get viewWidth() {
    return this.viewHeight * (this.width / this.height);
  }

  render() {
    this.renderer.render({ scene: this.scene, camera: this.camera });
  }
}
